var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box"},[_c('div',{staticClass:"info-box-title"},[_vm._v("Still need our help?")]),_c('div',{staticClass:"info-box-text"},[_vm._v("Contact us through email.")]),_c('button',{staticClass:"info-box-button"},[_vm._v("Contact us")])])
}]

export { render, staticRenderFns }